import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      const keyword = data.keyword.split(',')
      this.form = { ...data, keyword }
      const find = this.platformList.find(item => String(item.project) === String(this.form.project) &&
      String(item.staff_style) === String(this.form.staff_style) && String(item.type) === String(this.form.type)
      )
      this.form.line_id = find.id
      this.getKeywordList()
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.deleteRecommendKeyWord({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
